export const CAROUSEL_START_POSITION = 'START';
export const CAROUSEL_CURRENT_POSITION = 'CURRENT';
export const CAROUSEL_NO_MOVE_POSITION = 'NOMOVE';
export const CAROUSEL_NONE = 'NONE';

export type CAROUSEL_POSITON = 'START' | 'CURRENT' | 'NOMOVE' | 'NONE';
